import React from 'react';
import { Container, Row } from 'reactstrap';
import CustomerTable from './components/CustomerTable';
import PageHeader from '../../../shared/components/PageHeader';

const CustomerTables = () => (
  <Container>
    <Row>
      <PageHeader title="Customers" subhead="Current Customer List" />
    </Row>
    <Row>
      <CustomerTable />
    </Row>
  </Container>
);

export default CustomerTables;

